import * as React from 'react';

import { LocalizedDate, Row } from '@rematter/ui-web';

import { ContainerRecord } from '../../types/container';

import { useTranslations } from '~/modules/trade/i18n/useTranslations';

interface ContainerDetailsTimeStampsProps {
  container?: ContainerRecord;
}

export const ContainerDetailsTimeStamps: React.FC<
  ContainerDetailsTimeStampsProps
> = ({ container }) => {
  const t = useTranslations();

  return (
    <Row gap1 className="@ContainerDetailsTimeStamps">
      {t.containersView.detail.fields.createdAt}
      <LocalizedDate
        date={container?.timestamps.createdAt}
        dateStyle="medium"
      />
    </Row>
  );
};
